import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { uniqBy } from 'lodash';

import { Field } from 'redux-form';

import { changePatientResource } from 'redux/modules/patients';

import List from '@material-ui/core/List';

import OrderInformationSection from 'components/workflow/OrderInformation/OrderInformationSection';
import OrderInformationSectionTitle from 'components/workflow/OrderInformation/OrderInformationSectionTitle';
import OrderInformationSectionEmpty from 'components/workflow/OrderInformation/OrderInformationSectionEmpty';
import SalesRepresentativeCreateEditDialog from 'components/settings/SalesRepresentativeCreateEditDialog';
import SalesRepresentativesAddDialog from 'components/patient/PatientProfile/SalesRepresentatives/SalesRepresentativesAddDialog';
import OrderInformationSalesRepresentativeMenu from './OrderInformationSalesRepresentativeMenu';
import OrderInformationSalesRepresentativeField from './OrderInformationSalesRepresentativeField';

class OrderInformationSalesRepresentative extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addDialogOpen: false,
      createDialogOpen: false,
      anchorEl: null,
    };

    this.onMenuClose = this.onMenuClose.bind(this);
    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onAddButtonClick = this.onAddButtonClick.bind(this);
    this.onAddDialogClose = this.onAddDialogClose.bind(this);
    this.onCreateButtonClick = this.onCreateButtonClick.bind(this);
    this.onCreateDialogClose = this.onCreateDialogClose.bind(this);
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onMenuButtonClick(event) {
    const { Patient, fields } = this.props;
    const salesRepresentativeToAdd = fields.length > 0
      ? Patient['Sales Representative']
        .filter(item => fields.getAll().indexOf(item.ID) === -1)
      : Patient['Sales Representative'];
    if (salesRepresentativeToAdd.length > 0) {
      this.setState({ anchorEl: event.currentTarget });
    } else {
      this.setState({ addDialogOpen: true });
    }
  }

  onAddButtonClick() {
    this.setState({
      addDialogOpen: true,
      anchorEl: null,
    });
  }

  onAddDialogClose() {
    this.setState({ addDialogOpen: false });
  }

  onCreateButtonClick() {
    this.setState({
      addDialogOpen: false,
      createDialogOpen: true,
    });
  }

  onCreateDialogClose() {
    this.setState({ createDialogOpen: false });
  }

  render() {
    const { fields, Patient, actions, formValues, disabled, ...otherProps } = this.props;
    const { anchorEl, createDialogOpen, addDialogOpen } = this.state;
    const menuOpen = Boolean(anchorEl);
    const salesRepresentativeToAdd = fields.length > 0
      ? Patient['Sales Representative']
        .filter(item => fields.getAll().indexOf(item.ID) === -1)
      : Patient['Sales Representative'];
    return (
      <OrderInformationSection>
        {fields.length > 0 ? (
          <Fragment>
            <OrderInformationSectionTitle
              title="Sales Representative"
              addButtonOwns="order-information-add-sales-representative-menu"
              onAddButtonClick={this.onMenuButtonClick}
              addButtonDisabled={disabled}
            />
            <List disablePadding>
              {fields.map((salesRepresentativeItem, index) => (
                <Field
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  name={salesRepresentativeItem}
                  component={OrderInformationSalesRepresentativeField}
                  {...{ 'Sales Representative': uniqBy([
                    ...Patient['Sales Representative'] || [],
                    ...otherProps['Sales Representative'] || [],
                  ]) }}
                  onRemove={() => fields.remove(index)}
                  disabled={disabled}
                />
              ))}
            </List>
          </Fragment>
        ) : (
          <OrderInformationSectionEmpty
            title="Sales Representative"
            text="There are no sales person"
            type="salesRepresentative"
            addButtonOwns="order-information-add-sales-representative-menu"
            onAddButtonClick={this.onMenuButtonClick}
          />
        )}
        {salesRepresentativeToAdd.length > 0 &&
          <OrderInformationSalesRepresentativeMenu
            open={menuOpen}
            anchorEl={anchorEl}
            id="order-information-add-sales-representative-menu"
            onClose={this.onMenuClose}
            onItemClick={(item) => {
              this.onMenuClose();
              fields.push(item.ID);
            }}
            onAddButtonClick={this.onAddButtonClick}
            {...{ 'Sales Representative': salesRepresentativeToAdd }}
          />
        }
        <SalesRepresentativesAddDialog
          open={addDialogOpen}
          onClose={this.onAddDialogClose}
          onCreateButtonClick={this.onCreateButtonClick}
          onSubmitSuccess={(values) => {
            this.onAddDialogClose();
            new Promise((resolve, reject) => {
              actions.changePatientResource({
                'Record Number': Patient['Record Number'],
                'Sales Representative ID': [
                  values.ID,
                  ...Patient['Sales Representative'].map(item => item.ID),
                ],
                resolve,
                reject,
              });
            }).then(() => {
              if (fields.getAll() && fields.getAll().indexOf(values.ID) === -1) {
                fields.push(values.ID);
              }
            });
          }}
          formValues={formValues}
        />
        <SalesRepresentativeCreateEditDialog
          form="salesRepresentativeCreate"
          open={createDialogOpen}
          onClose={this.onCreateDialogClose}
          onSubmitSuccess={(values) => {
            this.onCreateDialogClose();
            new Promise((resolve, reject) => {
              actions.changePatientResource({
                'Record Number': Patient['Record Number'],
                'Sales Representative ID': [
                  values.ID,
                  ...Patient['Sales Representative'].map(item => item.ID),
                ],
                resolve,
                reject,
              });
            }).then(() => fields.push(values.ID));
          }}
        />
      </OrderInformationSection>
    );
  }
}

OrderInformationSalesRepresentative.propTypes = {
  fields: PropTypes.shape({
    name: PropTypes.string.isRequired,
    remove: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
  Patient: PropTypes.shape({
    'Record Number': PropTypes.number.isRequired,
  }).isRequired,
  'Sales Representative': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
  actions: PropTypes.shape({
    changePatientResource: PropTypes.func.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
};

OrderInformationSalesRepresentative.defaultProps = {
  'Sales Representative': [],
  formValues: {},
  disabled: false,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ changePatientResource }, dispatch),
});

export default connect(null, mapDispatchToProps)(OrderInformationSalesRepresentative);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationSalesRepresentative/OrderInformationSalesRepresentative.js